import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=044427b8&scoped=true&"
import script from "./Broadcast.vue?vue&type=script&lang=ts&"
export * from "./Broadcast.vue?vue&type=script&lang=ts&"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=044427b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044427b8",
  null
  
)

export default component.exports